(function($) {
	
	formHelper.addRule({
		form: '.form-manage-promoted-deal',
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			},
			ERROR_MESSAGE_ONE: function() {
				if(this.data.systemMessage1) {
					$('#system-message-1').html(this.data.systemMessage1);
				}
			},
			ERROR_MESSAGE_TWO: function() {
				if(this.data.systemMessage2) {
					$('#system-message-2').html(this.data.systemMessage2);
				}
			},
			ERROR_MESSAGE_THREE: function() {
				if(this.data.systemMessage3) {
					$('#system-message-3').html(this.data.systemMessage3);
				}
			},
			ERROR_MESSAGE_FOUR: function() {
				if(this.data.systemMessage4) {
					$('#system-message-4').html(this.data.systemMessage4);
				}
			},
			ERROR_MESSAGE_FIVE: function() {
				if(this.data.systemMessage5) {
					$('#system-message-5').html(this.data.systemMessage5);
				}
			}
		}

});

})(jQuery);

jQuery(function initToolsManagePromotedDeal($) {
	$('.manage-promoted-deal-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-manage-promoted-deal');

		// Date Restriction From Range
		// ------------------
		var $restrictionFromStart = $('#start-date-from').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var restrictionFromStartPicker = $restrictionFromStart.pickadate('picker');

		var $restrictionFromEnd = $('#start-date-to').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var restrictionFromEndPicker = $restrictionFromEnd.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( restrictionFromStartPicker.get('value') ) {
			restrictionFromEndPicker.set('min', restrictionFromStartPicker.get('select'));
		}
		
		if ( restrictionFromEndPicker.get('value') ) {
			restrictionFromStartPicker.set('max', restrictionFromEndPicker.get('select'));
		}

		// When something is selected, update the "restrictionFromStart" and "restrictionFromEnd" limits.
		restrictionFromStartPicker.on('set', function(event) {
			if ( event.select ) {
				restrictionFromEndPicker.set('min', restrictionFromStartPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				restrictionFromEndPicker.set('min', false);
			}
		});

		restrictionFromEndPicker.on('set', function(event) {
			if ( event.select ) {
				restrictionFromStartPicker.set('max', restrictionFromEndPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				restrictionFromStartPicker.set('max', false);
			}
		});


		// Date Restriction To Range
		// ------------------
		var $restrictionToStart = $('#end-date-from').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var restrictionToStartPicker = $restrictionToStart.pickadate('picker');

		var $restrictionToEnd = $('#end-date-to').pickadate({
			max: 730,
			selectYears: 5,
			selectMonths: true,
			labelMonthSelect: 'Select Month',
			labelYearSelect: 'Select Year',
			format: 'mm/dd/yyyy',
			formatSubmit: 'mm/dd/yyyy'
		});
		var restrictionToEndPicker = $restrictionToEnd.pickadate('picker');

		// Check if there’s a “from” or “to” date to start with.
		if ( restrictionToStartPicker.get('value') ) {
			restrictionToEndPicker.set('min', restrictionToStartPicker.get('select'));
		}
		
		if ( restrictionToEndPicker.get('value') ) {
			restrictionToStartPicker.set('max', restrictionToEndPicker.get('select'));
		}

		// When something is selected, update the "restrictionToStart" and "restrictionToEnd" limits.
		restrictionToStartPicker.on('set', function(event) {
			if ( event.select ) {
				restrictionToEndPicker.set('min', restrictionToStartPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				restrictionToEndPicker.set('min', false);
			}
		});

		restrictionToEndPicker.on('set', function(event) {
			if ( event.select ) {
				restrictionToStartPicker.set('max', restrictionToEndPicker.get('select'));
			}
			else if ( 'clear' in event ) {
				restrictionToStartPicker.set('max', false);
			}
		});		
	});
});

jQuery(function initToolsManagePromotedDealAddForm($) {
	$('.add-promoted-deal-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-add-promoted-deal');

		// Set the CKEDITOR WYSIWYG
		// CKEDITOR.replaceAll('do_ckeditor');

	});
});

jQuery(function initToolsManagePromotedDealResults($) {
	$('.manage-promoted-deal-results-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-manage-promoted-deal-results');
		var $pagesContainer        = $container.find('.tools-pages');
		var numPages               = $pagesContainer.data('pages');
		var currentPage            = $pagesContainer.data('start-page');

		for(var i = 1; i <= parseInt(numPages,10); i++) {
			if (i === parseInt(currentPage,10)) {
				currentClassCheck = " current";
			} else {
				currentClassCheck = '';
			}

			$pagesContainer.append('<div class="page' + currentClassCheck + '" data-page="' + i + '">' + i + '</div>');
		}

		// Bind all new page elements with page click function
		$(".page").click(function() {
			$('#filter-page').val($(this).data('page'));
			$form.submit();
		});

		// Bind refresh button
		$(".filter-refresh").click(function() {
			$('#filter-page').val(currentPage);
			$form.submit();
		});
	});
});

jQuery(function initEditPromotedDeal($) {
	$('.edit-promoted-deal-form').each(function(index, el) {

		var $container             = $(this);
		var $form                  = $container.find('#form-edit-promoted-deal');
		var $submitBtn             = $container.find('.btn-submit');
		var $copyBtn               = $container.find('.btn-copy');
		var $deleteBtn             = $container.find('.delete-button');

		// Set the CKEDITOR WYSIWYG
		// CKEDITOR.replaceAll('do_ckeditor');	

		$submitBtn.click(function() {
			$('#delete-promoted-deal').val('no');
			$('#pd-status').val('edit');
			/*
			for(var instanceName in CKEDITOR.instances) {
			    CKEDITOR.instances[instanceName].updateElement();
			}
			*/
			$form.submit();
		});

		$copyBtn.click(function() {			
			$('#delete-promoted-deal').val('no');
			$('#pd-status').val('copy');
			$form.submit();
		});

		$deleteBtn.click(function() {
			var r = confirm("Did you want to Continue?");
			if (r === true) {
			    $('#delete-promoted-deal').val('yes');
				$form.submit();
			}
		});
	});
});

